export default __webpack_public_path__ + "static/media/link.2b91121b.svg";